import { httpClient } from '@/shared/api/httpClient';

import { currentUserSchema } from '../model/types';
import type { CurrentUser, LoginInput, RegistrationInput } from '../model/types';

/**
 * Czyste funkcje endpointów — zero Reacta, zero stanu.
 * Dzięki temu dają się wołać z testów i z kodu spoza komponentów.
 */

export async function login(input: LoginInput): Promise<CurrentUser> {
  // `anonymous` — 401 z logowania to NORMALNA odpowiedź („złe hasło"), a nie
  // utrata sesji. Bez tego globalna obsługa 401 przekierowywałaby na logowanie
  // z ekranu logowania, czyli w kółko.
  const response = await httpClient.post<unknown>('/auth/login', input, {
    anonymous: true,
  });

  return currentUserSchema.parse(response);
}

export async function fetchCurrentUser(signal?: AbortSignal): Promise<CurrentUser | null> {
  try {
    const response = await httpClient.get<unknown>('/auth/me', {
      anonymous: true,
      ...(signal ? { signal } : {}),
    });

    return currentUserSchema.parse(response);
  } catch (error) {
    // 401 przy starcie aplikacji znaczy „nikt nie jest zalogowany" — to stan,
    // nie błąd. Rozróżnienie ma znaczenie: gdyby leciało jako błąd, każde wejście
    // na stronę logowania pokazywałoby komunikat o awarii.
    if (error instanceof Error && 'status' in error && error.status === 401) {
      return null;
    }

    throw error;
  }
}

export async function logout(): Promise<void> {
  await httpClient.post<void>('/auth/logout');
}

export async function register(token: string, input: RegistrationInput): Promise<void> {
  await httpClient.post<void>(
    `/registration/${encodeURIComponent(token)}`,
    input,
    { anonymous: true },
  );
}
